import Vue from "vue";
import VueRouter from "vue-router";
import Dashboard from "../views/Dashboard.vue";

Vue.use(VueRouter);

const routes = [{
    path: "/Login",
    name: "Login",
    component: () =>
        import("../views/Login.vue"),
},
{// Dashboard
    path: "/",
    name: "Dashboard",
    component: Dashboard,
    meta: {
        title: "داشبورد",
    },
}, {// Devices
    path: "/devices",
    name: "Devices",
    component: () => import("../views/Devices.vue"),
    meta: {
        title: "دستگاه ها",
    },
},
{// Add Device
    path: "/addDevice",
    name: "Add Device",
    component: () => import("../views/AddDevice.vue"),
    meta: {
        title: "اضافه کردن دستگاه",
    },
},
{// Account
    path: "/account",
    name: "Account Info",
    component: () => import("../views/Account.vue"),
    meta: {
        title: "تنظیمات حساب کاربری",
    },
},
{// Groups
    path: "/groups",
    name: "Group Management",
    component: () => import("../views/Groups.vue"),
    meta: {
        title: "تنظیمات گروه بندی",
    },
},


];

const Router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes,
});

export default Router;